import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Select,
  Button,
  VStack,
  HStack,
  Text,
  useToast,
} from '@chakra-ui/react';
import { getUserCreditProfiles, addUserCreditProfile } from '../../firebase/userCredits';
import CreditProfileForm from './CreditProfileForm';

const CreditSelector = ({ onCreditChange }) => {
  const [profiles, setProfiles] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState('');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const fetchProfiles = async () => {
      const { success, profiles, error } = await getUserCreditProfiles();
      if (success) {
        setProfiles(profiles);
      } else {
        toast({
          title: 'Error fetching credit profiles',
          description: error,
          status: 'error',
          duration: 3000,
        });
      }
      setIsLoading(false);
    };

    fetchProfiles();
  }, [toast]);

  const handleProfileChange = (e) => {
    const profileId = e.target.value;
    setSelectedProfileId(profileId);
    const selected = profiles.find((p) => p.id === profileId);
    if (selected) {
      onCreditChange({ creditProfileId: profileId, credits: selected });
    } else {
      onCreditChange({ creditProfileId: null, credits: null });
    }
  };

  const handleCreateNewProfile = () => {
    setShowCreateForm(true);
  };

  const handleFormSubmit = async (profileData) => {
    const { success, profile, error } = await addUserCreditProfile(null, profileData);
    if (success) {
      const newProfiles = [...profiles, profile];
      setProfiles(newProfiles);
      setSelectedProfileId(profile.id);
      onCreditChange({ creditProfileId: profile.id, credits: profile });
      setShowCreateForm(false);
      toast({
        title: 'Profile created',
        status: 'success',
        duration: 2000,
      });
    } else {
      toast({
        title: 'Error creating profile',
        description: error,
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <Box>
      <FormControl>
        <FormLabel>Image Credits</FormLabel>
        <HStack>
          <Select
            placeholder="Select a credit profile"
            value={selectedProfileId}
            onChange={handleProfileChange}
            isLoading={isLoading}
          >
            {profiles.map((profile) => (
              <option key={profile.id} value={profile.id}>
                {profile.name} ({profile.photographer})
              </option>
            ))}
          </Select>
          <Button onClick={handleCreateNewProfile}>New</Button>
        </HStack>
      </FormControl>

      {showCreateForm && (
        <Box mt={4}>
          <CreditProfileForm
            onSubmit={handleFormSubmit}
            onCancel={() => setShowCreateForm(false)}
          />
        </Box>
      )}
    </Box>
  );
};

export default CreditSelector;
